/**
 * Single source of truth for "is this account provisioned for the customer portal?".
 *
 * Mirrors the backend AuthGuard logic
 * (libs/api/crm-documents/feature-auth/src/lib/guards/auth.guard.ts):
 * a user is allowed through WITHOUT a customerNumber only if they hold a privileged
 * role. Everyone else must first link their Kundennummer (Debitorennummer) via the
 * registration flow.
 *
 * Kept free of React / server-only imports so it can run in the Next.js middleware
 * (edge) as well as in client components.
 *
 * Reused by:
 * - apps/crm-documents-client/src/middleware.ts (server-side redirect guard)
 * - feature-registration/.../register-flow.tsx (info banner + logout escape hatch)
 */
export const PORTAL_PRIVILEGED_ROLES = ['admin', 'shop_analytics'] as const;

export function hasPortalAccess(
  user?: { customerNumber?: string | null; roles?: string[] } | null,
): boolean {
  if (!user) return false;
  if (user.customerNumber) return true;
  const privileged: readonly string[] = PORTAL_PRIVILEGED_ROLES;
  return (user.roles ?? []).some((role) => privileged.includes(role));
}
